import { Report } from 'features/reporting/types'

import { AssetDrawings } from './sections/AssetDrawings'
import { Calibration } from './sections/Calibration'
import { ClientImages } from './sections/ClientImages'
// Import sections (to be created in step 2)
import { Cover } from './sections/Cover'
import { IndicationDetails } from './sections/IndicationDetails'
import { PDFGeneration } from './sections/PDFGeneration'
import { ReportReview } from './sections/ReportReview'
// Import static sections
import { DamageRatingAssessmentPage } from './sections/staticSections/DamageRatingAssessmentPage'
import { Summary } from './sections/Summary'
import { TOC } from './sections/TableOfContents'
import { WeldScanIndications } from './sections/WeldScanIndications'

export const rautReportForSPA: Report = {
  coverSection: Cover,
  tocSection: TOC,
  showSequentialNavigation: true,
  sections: [
    Summary,
    Calibration,
    ClientImages,
    AssetDrawings,
    IndicationDetails,
    WeldScanIndications,
  ],
  reviewSection: ReportReview,
  pdfGenerationSection: PDFGeneration,
  staticSections: [DamageRatingAssessmentPage],
}
